import { render, staticRenderFns } from "./since-last-visit-history.vue?vue&type=template&id=704074f1&"
import script from "./since-last-visit-history.vue?vue&type=script&lang=js&"
export * from "./since-last-visit-history.vue?vue&type=script&lang=js&"
import style0 from "./since-last-visit-history.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "since-last-visit-history.vue"
export default component.exports